<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/lp/omotenashiselection-header2.jpg" />
      </div>
    </div>
  </section>

  <section class="oms mt-5">
    <h2>マナビス フローラシリーズが<br>「おもてなしセレクション2024年 第2期」を受賞いたしました。</h2>
		<div class="oms-box">
			<div class="oms-txt">
				<p class="txt-cmn-01">「おもてなしセレクション」は、日本の優れた商品・サービスを世界に広めることを目的とした、民間企業20社以上で構成されるプロジェクトです。</p>
				<p class="txt-cmn-01">選定員による評価基準を満たした製品のみが受賞の対象となり、マナビス フローラシリーズの品質や独自性が認められる形となりました。</p>
				<p class="txt-cmn-01">今回の受賞により、フローラシリーズはANAの機関紙「翼の王国」を始め、さまざまなメディアや催事で紹介される予定です。</p>
				<p class="txt-cmn-01"><a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/assets/pdf/tsubasa_202412.pdf">ANAの機関紙「翼の王国」12月号</a>に掲載されている内容に関しては、PDFをご覧ください。</p>
				<p class="txt-cmn-01">おもてなしセレクションについて、より詳しくお知りになりたい方は、以下のリンクをご覧ください。</p>
				<p class="txt-cmn-01"><a href="https://omotenashinippon.jp/selection/" target="_blank">https://omotenashinippon.jp/selection/</a></p>
			</div>
			<div class="oms-img">
				<img class="txt-cmn-01" src="@/assets/img/lp/oms2024_logo_3.jpg"><br>
				<a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp/web/assets/pdf/tsubasa_202412.pdf"><img src="@/assets/img/lp/tsubasa_202412.jpg"></a>
			</div>
		</div>
  </section>
    



  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>


<style scoped>
.box-top-slide {
  height: initial;
}
button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}
.oms-box {
  display: flex;
  gap: 40px;
}
.oms-txt, .oms-img {
  width: 50%;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .oms-box {
    flex-wrap: wrap;
  }
  .oms-txt, .oms-img {
    width: 100%;
  }
  .oms-txt {
    order: 1;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>